import axios from "axios";
import { Programmation, StyleMusique } from "../../Models/Demande/DemandeModels"
import { errorService } from "../Error/ErrorService";
import { URLAPI } from "../../Setting";
import { DataThematique } from "../../Models/Admin/AdminModels";
import { FichierService } from "../Demande/FichierService";

export function StyleMusiqueService(){
    return{
        async getStylesMusiques(token:string){
            let styles:StyleMusique[]=[];
            try {
                const reponse = await axios.get(`${URLAPI+'styles'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                styles = data;
            } catch (error) {
                errorService().handleError("Erreur obtention Styles", error);
                return [];
            }
            return styles
        },

        async getStylesMusiquesThematiqueUser(token:string){
            let styles:StyleMusique[]=[];
            try {
                const reponse = await axios.get(`${URLAPI+'styles'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                for(const musique of data){
                    if(musique['thematique']){
                        styles.push({
                            id:musique['id'],
                            "@id":musique['@id'],
                            abreviation:musique['abreviation'],
                            nom:musique['nom'],
                            numero:musique['numero'],
                            thematique:musique['thematique'],
                            quota:musique['quota'],
                            fichiers:musique['fichiers'].map((url:string)=>{return {'@id':url}})
                        })
                    }
                }
            } catch (error) {
                errorService().handleError("Erreur obtention Styles", error);
                return [];
            }
            return styles
        },

        async getStylesMusiquesThematiqueAdmin(token:string){
            let styles:StyleMusique[]=[];
            try {
                const reponse = await axios.get(`${URLAPI+'styles'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                for(const musique of data){
                    if(musique['thematique']){
                        styles.push({
                            id:musique['id'],
                            "@id":musique['@id'],
                            abreviation:musique['abreviation'],
                            nom:musique['nom'],
                            numero:musique['numero'],
                            thematique:musique['thematique'],
                            quota:musique['quota'],
                            fichiers:musique['fichiers']
                        })
                    }
                }

                // for(let indexStyle=0;indexStyle<styles.length;indexStyle++){
                //     let initialStyle = styles[indexStyle];
                //     for(let indexFichier=0;indexFichier<initialStyle.fichiers.length;indexFichier++){
                //         const fichierResult = await FichierService().getFichierObjetViaURL(initialStyle.fichiers[indexFichier]["@id"], token);
                //         if(fichierResult){
                //             initialStyle.fichiers[indexFichier] = fichierResult;
                //             styles.map(style=>{
                //                 if(style.id===initialStyle.id)return initialStyle;
                //                 return style;
                //             })
                //         }
                //     }
                // }
            } catch (error) {
                errorService().handleError("Erreur obtention Styles", error);
                return [];
            }
            return styles
        },

        async deleteStyleMusique(idStyle:number, token:string){
            try {
                const reponse = await axios.delete(`${URLAPI+'style/'+idStyle}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                return reponse.status;
            } catch (error) {
                errorService().handleError("Erreur obtention Styles", error);
                return 400;
            }
        },

        async postStyleMusique(dataThematique:DataThematique, token:string){
            try {
                let idFichier:number[] = []
                if(dataThematique.extraitAudio){
                    const demandeFichier = await FichierService().postFichier(dataThematique.extraitAudio,token);
                    idFichier.push(demandeFichier.id);
                }
                

                let postStyleObject = {
                    "numero":1,
                    "nom": dataThematique.nom,
                    "abreviation": dataThematique.abreviation,
                    "thematique": true,
                    "quota": dataThematique.quota===0 ? undefined : dataThematique.quota,
                    "fichiers": idFichier
                }

                const reponse = await axios.post(`${URLAPI+'style'}`, 
                    postStyleObject,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":"application/ld+json"
                        },
                     }
                );
                return reponse.status;
            } catch (error) {
                errorService().handleError("Erreur ajout Style", error);
                return 400;
            }
        },

        async patchStyleMusique(dataThematique:DataThematique, token:string){
            try {
                if(dataThematique.fichiersThematiques.length>0){
                    await FichierService().deleteFichier(dataThematique.fichiersThematiques[0].id, token);
                }
                let idFichier:number[] = []
                if(dataThematique.extraitAudio){
                    const demandeFichier = await FichierService().postFichierStyle(dataThematique.extraitAudio, dataThematique.id,token);
                    idFichier.push(demandeFichier.id);
                }

                let patchStyleObject = {
                    "numero":dataThematique.id,
                    "nom": dataThematique.nom,
                    "abreviation": dataThematique.abreviation,
                    "thematique": true,
                    "quota": dataThematique.quota===0 ? undefined : dataThematique.quota,
                    "fichiers": idFichier
                }

                const reponse = await axios.patch(`${URLAPI+'style/'+dataThematique.id}`, 
                    patchStyleObject,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":"application/ld+json"
                        },
                    }
                );
                return reponse.status;
            } catch (error) {
                errorService().handleError("Erreur modification Style", error);
                return 400;
            }
        },

        async getProgrammationsSoiree(token:string){
            let programmations:Programmation[]=[];
            try {
                const reponse = await axios.get(`${URLAPI+'programmations'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                for(const musique of data){
                    programmations.push({
                        id:musique['id'],
                        "@id":musique['@id'],
                        // abreviation:musique['abreviation'],
                        nom:musique['nom'],
                        // numero:musique['numero'],
                        // thematique:musique['thematique']
                    })
                }
            } catch (error) {
                errorService().handleError("Erreur obtention Programmations", error);
                return [];
            }
            return programmations
        }
    }
}